import React from 'react';

const GLOWS = {
  'top-right':  'var(--glow-brand-top-right)',
  'top-center': 'var(--glow-brand-top-center)',
  'left':       'var(--glow-brand-left)',
  'none':       'none',
};

/**
 * Standard dark marketing band: ink-900 background with the brand-red
 * radial glow baked in. Replaces hand-placed blurred divs.
 * glow: 'top-right' (default) | 'top-center' | 'left' | 'none'
 * as:   HTML tag (default 'section')
 */
export const DarkSection = ({ children, glow = 'top-right', as: Tag = 'section', className = '', style = {}, ...props }) => (
  <Tag
    className={`relative overflow-hidden text-white ${className}`}
    style={{
      background: 'var(--surface-dark)',
      backgroundImage: GLOWS[glow] ?? GLOWS['top-right'],
      ...style,
    }}
    {...props}
  >
    {children}
  </Tag>
);

export default DarkSection;
